<div class="animated fadeInRight" *ngIf="!mostrarFormulario">
    <app-lfsa-card 
      [innTemplate]="carga" [titulo]="titulo" [efecto]="true" [colapseName]="'carga'"
      [banderaColapse]='false' [optionsExport]="true" (devolverAccion)="downloadCsvFormato()">
    </app-lfsa-card>

    <ng-template #carga>
      <form [formGroup]="formulario" novalidate class="form-group">
        <div class="row">
          <div class="form-group col-md-4">
            <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="comboList"
            formControlName="tipo" [control]="formulario.get('tipo')" [label]="'Tipo Catalogo*'" [id]="'tipo'">
            </app-lfsa-combo-box>
          </div>

          <div class="form-group col-md-4">            
            <label for="csvInput" class="letrasDanger">documento de carga.csv*</label>
            <input type="file" class="form-control-file" id="csvInput" #fileInput (change)="onFileSelect($event)" accept=".csv" />
          </div>

          <div class="form-group col-md-4">
            <label for="">&nbsp;</label>
            <button  [disabled]="formulario.invalid" (click)="enviarFormulario()" class="btn btn-success btn-block">Procesar</button>
          </div>
        </div>
      </form>
      <br>
    </ng-template>
  </div>
  
  <div *ngIf="mostrarFormulario">
    <app-lfsa-card [colapseName]="'grid'" [efecto]="true" [innTemplate]="grid" 
      [titulo]="'DATOS PARA PROCESAR'" 
      [banderaColapse]='false' 
      [optionsExport] ="false" 
      (devolverAccion)="downloadDataCsv()">
    </app-lfsa-card>

    <ng-template #grid>
      <div class="alert alert-danger" role="alert" *ngIf="listaVacia"> No existen datos para la lista.</div>
      <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="modulo.agGrid.class" [id]="modulo.agGrid.id" 
        [floatingFilter]="true"
        [frameworkComponents]="frameworkComponents"
        [ngStyle]="modulo.agGrid.style" 
        [columnDefs]="columnDefs" 
        [paginationPageSize]="modulo.agGrid.paginacion"
        [pagination]="true"                     
        [rowData]="rowData">
      </ag-grid-angular>
    </ng-template>

    <div class="row">
      <div class="form-group col-md-6">
        <button (click)="regresar()" class="btn btn-outline-danger btn-block btn-lg">Regresar</button>
      </div>
      <div class="form-group col-md-6">
        <button [disabled]="errorData" (click)="guardar()" class="btn btn-outline-success btn-block btn-lg">Guardar</button>
      </div>
    </div>

  </div>